import { Link } from 'react-router-dom'
import { ROUTES } from '@/constants'
import { Button } from '@/components/ui/button'

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-bg-secondary">
      <div className="text-center space-y-2">
        <h1 className="text-6xl font-bold text-text-primary font-display">404</h1>
        <p className="text-lg font-medium text-text-secondary">Página no encontrada</p>
        <p className="text-sm text-text-tertiary">La ruta que buscas no existe.</p>
      </div>
      <Button asChild variant="secondary">
        <Link to={ROUTES.HOME}>Volver al inicio</Link>
      </Button>
    </div>
  )
}
